export default __webpack_public_path__ + "static/media/webinars-1.72aa3ba2.jpg";